// Card image fallbacks (WO-08 step 6, D3).
// With CARD_IMAGE_MODE=mirror the API returns local /cimg/cards/... URLs and keeps the original
// URLs as images.largeSource / images.smallSource / image_large_source / image_small_source.
// nginx already falls back to the original when a local file is missing; these helpers are the
// browser-side second line: on an image error, try the original URL, then the placeholder.

export const PLACEHOLDER_CARD = '/placeholder-card.svg';

export function sourceImageUrls(card) {
  if (!card) return [];
  const images = card.images || {};
  return [images.largeSource, card.image_large_source, images.smallSource, card.image_small_source]
    .filter((u, i, all) => u && all.indexOf(u) === i);
}

// onError handler: walks `fallbacks` in order (skipping the URL that just failed), ends on the placeholder.
export function imageFallback(fallbacks = []) {
  return (e) => {
    const img = e.currentTarget;
    const list = [...fallbacks.filter(Boolean), PLACEHOLDER_CARD];
    let step = Number(img.dataset.fallbackStep || 0);
    while (step < list.length && img.src.endsWith(list[step])) step += 1;
    if (step >= list.length) return;
    img.dataset.fallbackStep = String(step + 1);
    img.src = list[step];
  };
}

// Hard-coded pokemontcg hires URLs (home page) -> mirrored copy when the build sets
// REACT_APP_CARD_IMAGE_MODE=mirror. Unknown URLs are returned unchanged.
const PTCG_HIRES = /^https:\/\/images\.pokemontcg\.io\/([A-Za-z0-9]+)\/([A-Za-z0-9]+)_hires\.png$/;

export function mirroredCardUrl(url) {
  if (process.env.REACT_APP_CARD_IMAGE_MODE !== 'mirror') return url;
  const m = PTCG_HIRES.exec(url || '');
  return m ? `/cimg/cards/${m[1]}-${m[2]}/large.webp` : url;
}
